'use client';

import { useEffect, useRef } from 'react';
import { createRoot, Root } from 'react-dom/client';
import AlertContainer from './AlertContainer';

const InitAlerts = ({ rootId = 'alert' }) => {
  const rootRef = useRef<Root | null>(null);

  useEffect(() => {
    const container = document.getElementById(rootId);
    if (!container) return undefined;

    rootRef.current = createRoot(container);
    rootRef.current.render(<AlertContainer />);

    return () => {
      rootRef.current?.unmount();
      rootRef.current = null;
    };
  }, []);

  return null;
};

export default InitAlerts;
